import { useHydrating } from "eddev/routing"
import { PropsWithChildren, useEffect, useState } from "react"
import { IconCross } from "./Icon"
import { AnimatePresence, motion } from "motion/react"
import { cn } from "@utils/tw"

type Props = PropsWithChildren<{
  className?: string
  onDismiss: () => void
}>

export function AlertBar(props: Props) {
  return (
    <div className="bg-bg-low border border-bg-mid rounded-sm text-fg type-ui-s flex items-center">
      <div className="p-2 flex-1">{props.children}</div>
      <button
        className="size-[1.5em] m-[0.3em] mr-[0.5em] flex-none text-fg-secondary hover:bg-bg-mid/90 rounded-sm inline-flex items-center justify-center"
        onClick={props.onDismiss}
      >
        <IconCross className="size-[1.5em] block" />
      </button>
    </div>
  )
}
